import React from "react";
import { Link } from "react-router-dom";
import { Activity, Brain, ShieldCheck } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-3xl mx-auto ss-fade-up" data-testid="about-page">
      <h1 className="text-3xl sm:text-4xl font-extrabold font-heading tracking-tight mb-3">
        About Aqvoro AI
      </h1>
      <p className="text-muted-foreground leading-relaxed">
        Aqvoro AI is an educational stock-scoring and learning platform. It scores a curated
        watchlist from 1–100 each day, ranks the top swing picks, explains the reasoning in plain
        English, and lets beginners practice with risk-free paper trading. Every number is derived
        from transparent technical indicators — momentum, moving-average trend and RSI — never from
        a black box.
      </p>

      <div className="grid sm:grid-cols-3 gap-4 mt-8">
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="h-10 w-10 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-3">
            <Activity className="h-5 w-5 text-primary" />
          </div>
          <h3 className="font-heading font-semibold mb-1">Daily Scoring</h3>
          <p className="text-sm text-muted-foreground">Transparent 1–100 scores recomputed after market close.</p>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="h-10 w-10 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-3">
            <Brain className="h-5 w-5 text-primary" />
          </div>
          <h3 className="font-heading font-semibold mb-1">Plain-English</h3>
          <p className="text-sm text-muted-foreground">Every pick comes with a beginner-friendly "why this pick" breakdown.</p>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="h-10 w-10 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-3">
            <ShieldCheck className="h-5 w-5 text-primary" />
          </div>
          <h3 className="font-heading font-semibold mb-1">Education First</h3>
          <p className="text-sm text-muted-foreground">Strictly a learning tool — never real-money advice.</p>
        </div>
      </div>

      <div className="mt-8 rounded-2xl border border-amber-500/20 bg-amber-500/10 p-5">
        <p className="text-sm text-amber-600 dark:text-amber-400/90 font-medium">
          Aqvoro AI is for educational purposes only and is not financial advice. No real money is
          involved. Always do your own research and consult a licensed advisor before investing.
        </p>
      </div>

      <p className="text-sm text-muted-foreground mt-8">
        Curious how the scores are built? Read our{" "}
        <Link to="/methodology" className="text-primary font-semibold hover:underline">methodology</Link>.
      </p>

      <div className="mt-8 rounded-2xl border border-border bg-card p-5" data-testid="about-creator">
        <h3 className="font-heading font-semibold mb-1">Created by Ahmed Faruqui</h3>
        <p className="text-sm text-muted-foreground">
          Have a question, idea or feedback? Reach out at{" "}
          <a href="mailto:ahmedfar683@gmail.com" className="text-primary font-semibold hover:underline" data-testid="about-contact-email">
            ahmedfar683@gmail.com
          </a>.
        </p>
      </div>

      <p className="text-xs text-muted-foreground mt-10">&copy; 2026 Aqvoro AI &middot; Built by Ahmed Faruqui. All rights reserved.</p>
    </div>
  );
}
